import { Brand, createBranded } from '@deltasierra/type-utilities';

export type ContentBuilderGroupLayerId = Brand<string, 'ContentBuilderGroupLayerId'>;
export const ContentBuilderGroupLayerId = createBranded<ContentBuilderGroupLayerId>();
